module.exports = __webpack_public_path__ + "img/744.cd3e0f81.jpg";